import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { environment } from '../environments/environment';
import { formatDate, Location } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { MediaMatcher } from '@angular/cdk/layout';
import { filter } from 'rxjs/operators';
import { sha256, sha224 } from 'js-sha256';
import { DOCUMENT } from '@angular/common';
import { TokenService } from './service/token.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { LoaderService } from './service/loader.service';
import { FormsModule } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';
import { SrvRecord } from 'dns';
//import { msalConfig } from './msal-config';

class MenuInfo {
  Id: number;
  MenuName: string;
  MenuURL: string;
  ParentId: string;
  Style: string;
}

class EmpInfo {
  ActiveFlag: string;
  TechnicianFlag: string;
  EmpCode: string;
  EmpCodeValidate: string;
  Username: string;
  password: string;
  UnitCode: string;
  EmpId: number;
  EmpFname_TH: string;
  EmpLname_TH: string;
  EmpName_TH: string;
  EmpName_EN: string;
  EmpFname_EN: string;
  EmpLname_EN: string;
  Title_TH: string;
  Title_EN: string;
  CreateBy: string;
  UpdateBy: string;
  ExpireDate: string;
  UpdateDate: string
  Mail: string;
  Mobile: string;
  PositionCode: string;
  BUCode: string;
  RoleCode: string;

  CompanyCode: string;
  CompanyName: string;

  UserType: string;
}

class LogLoginInfo {
  UserName: string;
  LoginDate: Date;
  Result: string;
  UserType: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnDestroy {
  showleft_menu: boolean = true;
  mobileQueryMax: MediaQueryList;

  isForK2: boolean = false;
  login_success: boolean = false;
  Username: string;
  UserExpireDate: string;
  UserEmpCode: string;
  UserEmail: string;
  ChackUpdateDate: string
  expiration_date: Date;
  todayPassword: Date;
  expireValue: string;
  todayValue: string;

  userTypes = [
    { value: 'INTERNAL', viewValue: 'Internal' },
    { value: 'EXTERNAL', viewValue: 'External' }
  ];
  selectedUserType: string = 'EXTERNAL';

  private _mobileQueryListener: () => void;

  ngOnDestroy(): void {
    this.mobileQueryMax.removeListener(this._mobileQueryListener)
    this.login_success = false
  }

  hide = true;

  username = new FormControl('', [Validators.required]);
  password = new FormControl('', [Validators.required]);

  getErrorMessage() {
    if (this.username.hasError('required')) {
      return 'You must enter a value';
    }

    if (this.password.hasError('required')) {
      return 'You must enter a value';
    }
  }

  title = 'my-project';

  public txtPassword: string;
  public txtUserName: string;

  MenuInfoPromise: Promise<MenuInfo[]>;
  EmpInfoPromise: Promise<EmpInfo[]>;

  private menu: MenuInfo[];
  private emp: EmpInfo[];

  baseurl: string;
  tokenurl: string;
  progresValue: number;

  appId: string;
  appVersion: string;

  @ViewChild('tomailInput') tomailInput: ElementRef<HTMLInputElement>;
  @ViewChild('ccmailInput') ccmailInput: ElementRef<HTMLInputElement>;
  ListEmpEmails: string[] = [];

  //To Mail chips params
  titleMail: string;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  tomailCtrl = new FormControl();
  tomails: string[] = [];
  filteredToMails: Observable<string[]>

  //CC Mail chips params
  ccmail_separatorKeysCodes: number[] = [ENTER, COMMA];
  ccmailCtrl = new FormControl();
  ccmails: string[] = [];
  filteredCCmails: Observable<string[]>
  Usermail: string;

  isLoggedIn = false;
  userName: string | null = null;

  passwordfromdb: string = ''; // Use from MSAL flow

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router
    , changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, @Inject(DOCUMENT) private document: Document
    , private activatedRoute: ActivatedRoute, public TokenService: TokenService, public loaderService: LoaderService
    , private authService: MsalService) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      //-------------- set scroll position to top ----------------
      window.scrollTo(0, 0)
      const el = document.querySelectorAll('mat-sidenav-content');
      if (el.length) {
        el[0].scrollLeft = 0;
        el[0].scrollTop = 0;
      }

      //-------------- end set scroll position to top ----------------

      //-------------- check url is potal ? if true hide left menu  ----------------
      if (event.url == '/portal') {
        this.showleft_menu = false;
      } else {
        this.showleft_menu = true;

      }
      //-------------- end check url is potal ? if true hide left menu  ----------------

      if (event.url == '/time-sheet') {
        var moduleId = "4";
        localStorage.setItem('ModuleId', moduleId);
        this.GetMenu();
      }

      if (event.url.lastIndexOf('/MenuPortal') > -1) {
        var moduleId = event.url.substring(event.url.lastIndexOf("ModulePortalId") + ("ModulePortalId").length + 1);
        localStorage.setItem('ModuleId', moduleId);
        this.GetMenu();
      }

    });

    router.events.subscribe((event) => {
      // see also 
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      //-------------- set scroll position to top ----------------
      window.scrollTo(0, 0)
      const el = document.querySelectorAll('mat-sidenav-content');
      if (el.length) {
        el[0].scrollLeft = 0;
        el[0].scrollTop = 0;
      }
      //-------------- end set scroll position to top ----------------

      //-------------- check url is potal ? if true hide left menu  ----------------
      if (event.url == '/portal') {
        this.showleft_menu = false;
      } else {
        this.showleft_menu = true;

      }
      //-------------- end check url is potal ? if true hide left menu  ----------------

      if (event.url.lastIndexOf('/MenuPortal') > -1) {
        var moduleId = event.url.substring(event.url.lastIndexOf("ModulePortalId") + ("ModulePortalId").length + 1);
        localStorage.setItem('ModuleId', moduleId);

        this.GetMenu();
      }

    });




    this.appId = environment.appId;
    this.appVersion = environment.appversion;
    this.baseurl = environment.base_api;
    this.tokenurl = environment.token_api;
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQueryMax = media.matchMedia('(max-width:600px)')
    this.mobileQueryMax.addListener(this._mobileQueryListener);

    this.progresValue = 0;


    //Is For K2

    if (!!this.activatedRoute.snapshot.params.ForK2) {
      this.isForK2 = true;
    }

    // MSAL Service - check account login
    this.checkAccount();
  }

  columnMenu = [
    { headerName: 'Id', field: 'Id', width: 100 },
    { headerName: 'Menu Name', field: 'MenuName', width: 100 },
    { headerName: 'Menu Url', field: 'MenuURL', width: 100 },
    { headerName: 'ParentId', field: 'ParentId', width: 100 },
    { headerName: 'Style', field: 'Style', width: 100 }
  ];



  async ngOnInit() {

    var listUrl = window.location.href.split('/');
    if (listUrl.lastIndexOf("Y") > -1) {
      this.isForK2 = true;
      this.login_success = true;
      this.router.navigateByUrl(window.location.pathname);
      return;
    } else {

      this.document.documentElement.lang = 'es';

      this.Loginvalidation();
    }

    //console.log('App component initialized. Listening for redirect...');
    // handleRedirectObservable() จะทำงานเมื่อ Microsoft login redirect กลับมาที่แอป
    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult | null) => {
        if (result && result.account) {
          //console.log('Microsoft login successful!', result.account);

          this.authService.instance.setActiveAccount(result.account); // Set Active Account

          const email = result.account.username;
          console.log('Logged-in user email:', email);
          this.AutoLoginWithDbFromMSALAccount(email);

        } else {
          console.log('Redirect handled, but no account found.');

          // กรณีนี้จะเกิดขึ้น:
          // - ผู้ใช้กด Cancel หน้า Microsoft login
          // - Redirect กลับมาที่แอปแต่ไม่ได้ login
          // - หรือ Token ไม่ถูกต้อง/หมดอายุ
          // สามารถแสดงปุ่มให้ login ใหม่ได้
        }
      },
      error: (error) => {
        console.error('Error occurred during Microsoft login redirect:', error);

        // ตรงนี้คือจุด handle error เช่น:
        // - แสดง error message
        // - ให้ผู้ใช้ลอง login ใหม่
      }
    });
  }
  /////////////////////////////////Events///////////////////////////////////////////

  async btnLoginClick() {

    if (this.txtUserName == null || this.txtUserName == "") {
      document.getElementById("LoginMsg").innerHTML = "<font color=\"red\">Please check required fields.</font>";
      return false;
    }

    document.getElementById("signin-button-id").setAttribute('disabled', '');

    let isAccountLocked = await this.IsAccountLocked(this.txtUserName).then(response => {
      return response;
    });

    if (!isAccountLocked) {

      //var auth_token = localStorage.getItem("refreshToken");
      let flaglogin: boolean = await this.GetLogin(this.txtUserName, sha256(this.txtPassword))
        .then(async result => {

          this.emp = result;

          if (this.emp.length > 0) {
            if (typeof (Storage) !== "undefined") {
              // Store
              for (let item of this.emp) {
                localStorage.setItem("EmpCode", item.EmpCode);
                localStorage.setItem("UserName", item.Mail);
                localStorage.setItem("EmpName_TH", item.EmpName_TH);
                localStorage.setItem("EmpFName_EN", item.EmpFname_EN);
                localStorage.setItem("EmpRoleCode", item.RoleCode);
                localStorage.setItem("EmpMail", item.Mail);
                localStorage.setItem("ExpireDate", item.ExpireDate);
                localStorage.setItem("UpdateDate", item.UpdateDate);
                localStorage.setItem("CompanyCode", item.CompanyCode);
                localStorage.setItem("CompanyName", item.CompanyName);
                localStorage.setItem("UserType", this.selectedUserType);

                this.expiration_date = new Date(item.ExpireDate);
                this.todayPassword = new Date();

                const ExpireValue = formatDate(this.expiration_date, 'yyyy-MM-dd', 'en-US');
                const TodayValue = formatDate(this.todayPassword, 'yyyy-MM-dd', 'en-US');

                this.expireValue = ExpireValue;
                this.todayValue = TodayValue;
                this.Username = item.EmpName_TH;
                //this.UserExpireDate = item.ExpireDate;
                this.UserEmpCode = item.EmpCode;
                this.UserEmail = item.Mail;
                this.ChackUpdateDate = item.UpdateDate;

              }


              if (this.UserExpireDate === null || this.ChackUpdateDate === this.UserExpireDate || this.expireValue <= this.todayValue) {
                //this.showleft_menu = true;
                this.isForK2 = true;
                this.router.navigateByUrl('/user-password-expire/Y/Y;EmpCode=' + this.UserEmpCode + ';Email=' + this.UserEmail);
              } else {
                this.showleft_menu = false;
                this.router.navigateByUrl('/portal');
              }


            }

            let tempappid = this.appId;

            console.log("CURRENT APPID");
            console.log(tempappid);
            if (this.selectedUserType == "INTERNAL") tempappid = "JOINSPLUS";

            console.log("NEW APPID");
            console.log(tempappid);

            let getTokenSuccess = await this.TokenService.GetToken(this.txtUserName, sha256(this.txtPassword), tempappid).then(response => {
              if (!response.isError) {
                localStorage.setItem("email", response.data.email);
                localStorage.setItem("expiredTime", response.data.expiredTime);
                localStorage.setItem("guidId", response.data.guidId);
                localStorage.setItem("refreshToken", response.data.refreshToken);//auth token
                localStorage.setItem("token", response.data.token);

                return true;
              } else {
                return false;
              }
            }).catch(err => {
              return false;
            });

            if (getTokenSuccess) {
              this.GetMenu();
              this.login_success = true;
              this.LogAttempt(this.txtUserName, "OK");

              return true;

            } else {
              document.getElementById("LoginMsg").innerHTML = "<font color=\"red\">Unable to fetch token: " + this.txtUserName + "</font>";
              this.login_success = false;

              return false;
            }



          } else {

            document.getElementById("LoginMsg").innerHTML = "<font color=\"red\">Log in failed! Please try again.</font>";
            this.login_success = false;
            this.LogAttempt(this.txtUserName, "NG");

            return false;

          }
        })
        .catch((err) => {
          console.log(err);
          return false;
        });

      
    } else {

      document.getElementById("LoginMsg").innerHTML = "<font color=\"red\">Your Account is Temporarily Locked. Please try again in 30 minutes." + "</font>";

    }

    document.getElementById("signin-button-id").removeAttribute('disabled');
  }

  //////////////////////////////////functions//////////////////////////////////////////////

  async GetMenu() {
    let EmpCode: string
    let ModuleId: string

    EmpCode = localStorage.getItem("EmpCode");
    ModuleId = localStorage.getItem("ModuleId");

    let strmenu = ""
    this.login_success = true;

    var auth_token = await this.TokenService.RefreshToken();
    this.MenuInfoPromise = await this.LoadMenu(EmpCode, ModuleId, auth_token).then(result => {
      this.menu = result;

      return result;
    });
  }

  LoadMenu(EmpCode, ModuleId, auth_token): Promise<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectData = {};

    objectData['RoleCode'] = localStorage.getItem('EmpRoleCode');
    objectData['ModuleId'] = ModuleId;

    let strjson = JSON.stringify(objectData);

    return this.MenuInfoPromise = this.httpClient
      .post<MenuInfo[]>(this.baseurl + "Menu/GetMenu", strjson, httpOptions)
      .toPromise()
  }

  GetLogin(UserName, Password): Promise<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
        // , 'Authorization': `Bearer ${auth_token}`
      })
    };


    let objData = {};
    objData["Mail"] = UserName;
    objData["Password"] = Password;
    objData["UserType"] = this.selectedUserType;

    let strjson = JSON.stringify(objData);

    this.EmpInfoPromise = this.httpClient
      .post<EmpInfo[]>(this.baseurl + 'UserLogin/getUserLogin', strjson, httpOptions)
      .toPromise()

    return this.EmpInfoPromise;
  }

  async IsAccountLocked(UserName: string): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    let objData = {};
    objData["UserName"] = UserName;
    objData["UserType"] = this.selectedUserType;

    let strjson = JSON.stringify(objData);

    return this.httpClient
      .post<LogLoginInfo[]>(this.baseurl + 'LogLogin/IsAccountLocked', strjson, httpOptions).toPromise().then(data => {
        return data;
      }).catch((err: HttpErrorResponse) => {
        // simple logging, but you can do a lot more, see below
        console.error('An error occurred:', err.error);
      });
  }


  LogAttempt(UserName, status) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };


    let objData = {};
    objData["UserName"] = UserName;
    objData["Result"] = status;
    objData["UserType"] = this.selectedUserType;


    let strjson = JSON.stringify(objData);

    this.httpClient
      .post<LogLoginInfo[]>(this.baseurl + 'LogLogin/LogAttempt', strjson, httpOptions).toPromise();
  }


  Loginvalidation() {
    if (typeof (Storage) !== "undefined") {
      var empCode = localStorage.getItem("EmpCode");
      if (!!empCode) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };

        var objectjson = {};
        objectjson["EmpCode"] = empCode;

        let strjson = JSON.stringify(objectjson);

        this.httpClient
          .post<boolean>(this.baseurl + "UserLogin/LoginValidation",
            strjson, httpOptions)
          .toPromise().then(data => {
            
            if (data) {
              this.login_success = true;
              this.Username = localStorage.getItem("EmpName_TH");
              if (window.location.pathname != '/') {
                this.router.navigateByUrl(window.location.pathname);

              } else {
                this.showleft_menu = false;
                this.router.navigateByUrl('/portal');
              }

              this.GetMenu();

            } else {
              this.login_success = true
              this.isForK2 = true
              this.router.navigateByUrl('/user-password-expire/Y/Y;EmpCode=' + empCode + ';Email=' + localStorage.getItem('EmpMail'));
            }
          });
      }
    }
  }

  displaysub(subid) {
    if (localStorage.getItem("MenuId") != null) {
      if (document.getElementById(localStorage.getItem("MenuId")) != null) {
        document.getElementById(localStorage.getItem("MenuId")).style.display = 'none';
      }
      localStorage.setItem("MenuId", subid);
    }

    document.getElementById(subid).style.display = 'block';
  }

  btnClick_LogOut(login_status: boolean) {
    this.login_success = login_status
  }

  OnBtnOpenForGetPasswordModalClick() {
    $('#ModalForgetPassword').modal();
  }

  OnBtnConfirmSendMailClick() {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var objectjson = {};

    objectjson["Mail"] = this.Usermail;
    objectjson["EmailsTo"] = [this.Usermail];
    //objectjson["EmailsCC"] = this.ccmails;

    let strjson = JSON.stringify(objectjson);

    this.httpClient
      .post<any[]>(this.baseurl + "UserLogin/SendMailForgot",
        strjson, httpOptions)
      .toPromise().then(data => {

        var result = true;
        $.each(data, function (i) {
          if (data[i].result_code != '200') {
            result = false;
          }
        });

        if (result) {
          $('#ModalForgetPassword').modal('hide');
        }

      });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.tomails.push(value);
    }

    // Clear the input value
    //event.chipInput!.clear();

    this.tomailCtrl.setValue(null);
  }
  add_ccmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.ccmails.push(value);
    }

    this.ccmailCtrl.setValue(null);
  }

  async btnLoginwithMicrosoftClick0() {
  this.authService.loginRedirect(); // จะพา user ไปหน้า Microsoft Login
  console.log("55");

  // Handle callback หลัง loginRedirect
    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult | null) => {
        if (result) {
          console.log("Login success:", result.account);
        }
      },
      error: (err) => {
        console.error("Login error:", err);
      }
    });
}

  btnLoginwithMicrosoftClick1() {
    console.log("Login with Microsoft Clicked");
    const loginRequest = {
      scopes: ['User.Read'],
    };

    try {
      this.authService.loginRedirect(loginRequest);
      console.log('Redirecting...');
    } catch (error) {
      console.error("An error occurred during loginRedirect:", error);
    }
  }

  btnLoginwithMicrosoftClick() {
  const loginRequest = {
    scopes: ['User.Read'],
    prompt: 'login' // 👈 เพิ่มบังคับให้ขึ้นหน้า Microsoft Login เสมอ
  };

  try {
    this.authService.loginRedirect(loginRequest);
    console.log('Redirecting...');
    } catch (error) {
      console.error("An error occurred during loginRedirect:", error);
    }
  }


  logout() {
    this.authService.logoutRedirect();
  }

  private checkAccount() {
  const account = this.authService.instance.getActiveAccount();
  if (account) {
    this.isLoggedIn = true;
    this.userName = account.name ?? null;

    //console.log(" Login Success!");
    //console.log("Account Info:", account);
  } else {
    console.log(" No active account, user not logged in");
  }
}

async getUserProfile() {
  try {
    const tokenResponse = await this.authService.instance.acquireTokenSilent({
      scopes: ["User.Read"]
    });

    console.log(" Access Token:", tokenResponse.accessToken);

    this.httpClient.get('https://graph.microsoft.com/v1.0/me', {
      headers: {
        Authorization: `Bearer ${tokenResponse.accessToken}`
      }
    }).subscribe(profile => {
      console.log(" Microsoft Profile:", profile);
    });

  } catch (error) {
    console.error(" Token acquire error:", error);
  }
}

async AutoLoginWithDbFromMSALAccount(email: string) {

    if (email == null || email == "") {
      return false;
    }

    document.getElementById("signin-button-id").setAttribute('disabled', '');
    
    this.txtUserName = email;
    this.txtPassword = "";

    if (email) {
      //var auth_token = localStorage.getItem("refreshToken");
      let flaglogin: boolean = await this.GetLogin(this.txtUserName, this.txtPassword)
        .then(async result => {

          this.emp = result;
          //console.log('empPassword!!!', result[0].Password);

          if (this.emp.length > 0) {
            if (typeof (Storage) !== "undefined") {
              // Store
              for (let item of this.emp) {
                localStorage.setItem("EmpCode", item.EmpCode);
                localStorage.setItem("UserName", item.Mail);
                localStorage.setItem("EmpName_TH", item.EmpName_TH);
                localStorage.setItem("EmpFName_EN", item.EmpFname_EN);
                localStorage.setItem("EmpRoleCode", item.RoleCode);
                localStorage.setItem("EmpMail", item.Mail);
                localStorage.setItem("ExpireDate", item.ExpireDate);
                localStorage.setItem("UpdateDate", item.UpdateDate);
                localStorage.setItem("CompanyCode", item.CompanyCode);
                localStorage.setItem("CompanyName", item.CompanyName);
                localStorage.setItem("UserType", this.selectedUserType);

                this.passwordfromdb = result[0].Password;

                this.expiration_date = new Date(item.ExpireDate);
                this.todayPassword = new Date();

                const ExpireValue = formatDate(this.expiration_date, 'yyyy-MM-dd', 'en-US');
                const TodayValue = formatDate(this.todayPassword, 'yyyy-MM-dd', 'en-US');

                this.expireValue = ExpireValue;
                this.todayValue = TodayValue;
                this.Username = item.EmpName_TH;
                //this.UserExpireDate = item.ExpireDate;
                this.UserEmpCode = item.EmpCode;
                this.UserEmail = item.Mail;
                this.ChackUpdateDate = item.UpdateDate;

              }


              if (this.UserExpireDate === null || this.ChackUpdateDate === this.UserExpireDate || this.expireValue <= this.todayValue) {
                //this.showleft_menu = true;
                this.isForK2 = true;
                this.router.navigateByUrl('/user-password-expire/Y/Y;EmpCode=' + this.UserEmpCode + ';Email=' + this.UserEmail);
              } else {
                this.showleft_menu = false;
                this.router.navigateByUrl('/portal');
              }


            }

            let tempappid = this.appId;

            console.log("CURRENT APPID");
            console.log(tempappid);
            if (this.selectedUserType == "INTERNAL") tempappid = "JOINSPLUS";

            console.log("NEW APPID");
            console.log(tempappid);

            let getTokenSuccess = await this.TokenService.GetToken(this.txtUserName, this.passwordfromdb, tempappid).then(response => {
              if (!response.isError) {
                localStorage.setItem("email", response.data.email);
                localStorage.setItem("expiredTime", response.data.expiredTime);
                localStorage.setItem("guidId", response.data.guidId);
                localStorage.setItem("refreshToken", response.data.refreshToken);//auth token
                localStorage.setItem("token", response.data.token);

                return true;
              } else {
                return false;
              }
            }).catch(err => {
              return false;
            });

            if (getTokenSuccess) {
              this.GetMenu();
              this.login_success = true;
              this.LogAttempt(this.txtUserName, "OK");

              return true;

            } else {
              document.getElementById("LoginMsg").innerHTML = "<font color=\"red\">Unable to fetch token: " + this.txtUserName + "</font>";
              this.login_success = false;

              return false;
            }



          } else {

            document.getElementById("LoginMsg").innerHTML = "<font color=\"red\">Log in failed! Please try again.</font>";
            this.login_success = false;
            this.LogAttempt(this.txtUserName, "NG");

            return false;

          }
        })
        .catch((err) => {
          console.log(err);
          return false;
        });

      
    } else {

      document.getElementById("LoginMsg").innerHTML = "<font color=\"red\">Your Account is Temporarily Locked. Please try again in 30 minutes." + "</font>";

    }

    document.getElementById("signin-button-id").removeAttribute('disabled');
  }

}
